<template>
  <div>
    <table
      style="border:1px solid #e5e5e5;"
      v-if="this.$root.cache.getOptions[84]"
      class="uk-table uk-table-hover uk-table-middle uk-table-divider"
    >
      <thead>
        <tr>
          <th>Language</th>
          <th>Value</th>
        </tr>
      </thead>
      <tr v-for="jData in this.$root.cache.getOptions[84]">
        <th class="nopgmr">
          <label>{{ jData.label }}</label>
        </th>
        <td class="nopgmr">
          <input type="text" v-model="jsonModel[jData.code]" class="uk-input" />
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
export default {
  name: "json",
  data() {
    return {
      editForm: null,
      model: [],
      jsonModel: []
    };
  },
  props: ["input", "form", "value"],
  created() {
    this.$forceUpdate();
  },
  methods: {
    resetItem() {
      this.jsonModel = [];
      Object.entries(Object.assign({}, JSON.parse(this.model))).forEach(
        element => {
          this.jsonModel.push({
            key: element[0],
            val: element[1]
          });
        }
      );
    },
    deleteItem(item) {
      this.jsonModel.splice(this.jsonModel.indexOf(item), 1);
    },
    addItem() {
      this.jsonModel.push({ key: "", val: "" });
    }
  },
  watch: {
    jsonModel: {
      deep: true,

      handler() {
        this.$parent.$emit("changed", {
          name: this.input.name,
          value: JSON.stringify(Object.assign({}, this.jsonModel))
        });
      }
    }
  }
};
</script>

<style>
.nopgmr {
  margin: 0px !important;
  padding: 2px !important;
  align-items: center;
  text-align: center;
}

.nopgmr input {
  border: none !important;
  box-shadow: none;
  background: none;
}

th.nopgmr {
  background: #eee;
}
</style>
